import TrainingFeature from './feature';
import register from "./store";

export default TrainingFeature;
export {
    register
}
